import {required,numeric} from "vuelidate/lib/validators";  
const satdosyamalzeme = {
    data() { 
      return {   
        satdosyamalzemeData: { 
          Dosyaid: "",
          Sirano:0,
          Malzemeid: null,
          Olcubirimi:"",
          Adet: null,
          Aciklama: "",
          Deleted: false,

          }, 
          FormDataType:{
            Dosyaid:{FieldName:"Dosyaid",Field:"input"},
            Sirano:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('satdosyamalzeme.MalzemeEkle.Sirano'),FieldType:"number"},
            Malzemeid:{FieldName:"Malzemeid",Field:"input",FieldTitle:this.$t('satdosyamalzeme.MalzemeEkle.Malzemeid'),ComboDataArray:[]}, 
            Olcubirimi:{FieldName:"Olcubirimi",Field:"input",FieldTitle:this.$t('satdosyamalzeme.MalzemeEkle.Olcubirimi'),ComboDataArray:[]}, 
   //         Adet:{FieldName:"Adet",Field:"input",FieldTitle:this.$t('satdosyamalzeme.MalzemeEkle.Adet'),FieldType:"number"}, //
            Adet:{FieldName:"Adet",Field:"input",FieldTitle:this.$t('satdosyamalzeme.MalzemeEkle.Adet'),FieldType: "number"},
            Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:this.$t('satdosyamalzeme.MalzemeEkle.Aciklama'),FieldType:"text"}, 
          } 
      }
    }, 
    validations:{ 
      FormData: { 
        Dosyaid: { required },
        Sirano: { required, numeric },
        Malzemeid: { required },
        Olcubirimi:{ required },
        Adet: { required },
        Aciklama: {},
   
      }
 
  },
  created(){
   /*     let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }


      this.ActionsGet({"Service":"OMalzeme", "Page":Page}).then((res) => {
          for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Malzemeid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adi,Olcubirimi:res.Data[i].Olcubirimi})
          } 

      });  */

      this.ActionsSabitGet(201).then(res => {  
        for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Olcubirimi.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
          }    
      }); 
  }
}
export default satdosyamalzeme